<section class="edp-dashboard-simple-grid pt-4 pt-md-4 d-flex flex-wrap" [ngClass]="{'margin-mobile-view': !isApp}">
    <div class="d-flex d-mobile">
        <edp-es-widget-order></edp-es-widget-order>
    </div>
    <div class="widget-solar d-flex d-mobile">
        <edp-widget-solar></edp-widget-solar>
    </div>
</section>
